import type PersonaPostalAddress from 'owa-service/lib/contract/PersonaPostalAddress';
import type PostalAddressAttributedValue from 'owa-service/lib/contract/PostalAddressAttributedValue';
import type FindWeatherLocationSuggestionsResponse from 'owa-calendar-scheduling-service/lib/schema/FindWeatherLocationSuggestionsResponse';
import type LocationPersonaType from 'owa-calendar-scheduling-service/lib/schema/LocationPersonaType';

/**
 * Convert FindWeatherLocations response object to Location PersonaTypes
 */
export default function weatherLocationSuggestionsResponseToLocationPersonaType(
    findWeatherLocationSuggestionsResponse: FindWeatherLocationSuggestionsResponse
): LocationPersonaType[] {
    let personas: LocationPersonaType[] = [];
    if (findWeatherLocationSuggestionsResponse) {
        if (findWeatherLocationSuggestionsResponse.Suggestions) {
            findWeatherLocationSuggestionsResponse.Suggestions.map((suggestion, index) => {
                const postalAddress = suggestion.location.postalAddress;
                let address: PostalAddressAttributedValue = {
                    Attributions: ['0'],
                    Value: {
                        City: postalAddress.city,
                        State: postalAddress.state,
                        Country: postalAddress.country,
                        Latitude: postalAddress.latitude,
                        Longitude: postalAddress.longitude,
                    } as PersonaPostalAddress,
                };

                const hasCity = postalAddress.city;
                const hasCoordinates = postalAddress.latitude && postalAddress.longitude;

                if (hasCity || hasCoordinates) {
                    personas.push({
                        PersonaId: {
                            Id: suggestion.id,
                        },
                        DisplayName: suggestion.location.displayName,
                        PersonaTypeString: 'Place',
                        BusinessAddressesArray: [address],
                    } as LocationPersonaType);
                }
            });
        }
    }
    return personas;
}
